import { useLastShowWhatsNewVersion } from '@/utils/fetchers/base'
import { useDeviceType } from '@/utils/hooks/useMediaQuery'
import { showWhatsNewModal } from '@/utils/whatsNew'
import { css } from '@emotion/react'
import { IconSparkles } from '@tabler/icons-react'
import { type HTMLMotionProps } from 'motion/react'
import { useMemo } from 'react'
import pkg from '../../package.json'
import ClickWrapper from './ClickWrapper'

export interface WhatsNewTipProps extends HTMLMotionProps<'div'> {}

// 处理图标和渐变的子组件
function GradientIcon() {
	return (
		<>
			<IconSparkles
				size={24}
				css={css`
					stroke: url('#icon-gradient');

					path {
						stroke: inherit;
					}
				`}
			/>
			{/* 添加 SVG 渐变定义 */}
			<svg width="0" height="0">
				<defs>
					<linearGradient id="icon-gradient" x1="0%" y1="0%" x2="100%" y2="0%">
						<stop offset="0%" stopColor="var(--tint-jike-yellow)" />
						<stop offset="100%" stopColor="var(--tint-jike-blue)" />
					</linearGradient>
				</defs>
			</svg>
		</>
	)
}

// 处理内容的子组件
function Content() {
	return (
		<div
			css={css`
				background: linear-gradient(to right, var(--tint-jike-yellow), var(--tint-jike-blue));
				background-clip: text;
				color: transparent;
			`}
		>
			<div
				css={css`
					font-weight: 600;
				`}
			>
				What&#39;s New
			</div>
		</div>
	)
}

export default function WhatsNewTip({ ...props }: WhatsNewTipProps) {
	const [lastShowWhatsNewVersion, setLastShowWhatsNewVersion] = useLastShowWhatsNewVersion()
	const { isMobile } = useDeviceType()

	const animationProps = useMemo(
		() => ({
			initial: {
				opacity: 0,
				y: '100%',
			},
			animate: {
				opacity: 1,
				y: lastShowWhatsNewVersion === pkg.version ? '100%' : 0,
				transition: {
					duration: 0.6,
					delay: 3,
					type: 'spring',
					damping: 20,
				},
			},
		}),
		[lastShowWhatsNewVersion]
	)

	if (isMobile) {
		return null
	}

	return (
		<ClickWrapper
			whileTap={{
				scale: 0.98,
			}}
			onClick={() => {
				showWhatsNewModal()
				setLastShowWhatsNewVersion(pkg.version)
			}}
			css={css`
				position: fixed;
				z-index: 1;
				right: 32px;
				bottom: -1px;
				background-color: var(--bg-body-1);
				box-shadow: 0 0 4px 1px var(--solid-shadow-1);
				border-radius: 12px 12px 0 0;
				border: 1px solid var(--tint-separator);
				display: flex;
				align-items: center;
				justify-content: center;
				gap: 4px;
				padding: 8px 12px;
			`}
			{...animationProps}
			{...props}
		>
			<GradientIcon />
			<Content />
		</ClickWrapper>
	)
}
